import { render, staticRenderFns } from "./WidgetEconomicEcosystem.vue?vue&type=template&id=4b2c78f8&scoped=true"
import script from "./WidgetEconomicEcosystem.vue?vue&type=script&lang=ts"
export * from "./WidgetEconomicEcosystem.vue?vue&type=script&lang=ts"
import style0 from "./WidgetEconomicEcosystem.vue?vue&type=style&index=0&id=4b2c78f8&prod&scoped=true&lang=scss"
import style1 from "./WidgetEconomicEcosystem.vue?vue&type=style&index=1&id=4b2c78f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c78f8",
  null
  
)

export default component.exports